import Slider from 'components/3catinfo/Slider';
import Destacat from 'components/3catinfo/Destacat';
import styles from './tiraaudios.module.scss';

const TiraAudios = (props) => {
    const { items, titol, format = 'destacatVideo' } = props;
    return (
        <>
            {items && (
                <div className={styles.tiraAudios}>
                    <Slider titol={titol} format={format} estil='tiraVideos' estilModul='modulTiraVideos' fletxes='mig'>
                        {items.map((item) => (
                            <Destacat
                                key={`destacat-audio-${item.id}`}
                                item={item}
                                routePath='web_3cat_audio_item'
                                enllacExtern3Cat={true}
                                estil='box-0'
                            />
                        ))}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default TiraAudios;
